<template>
  <CheckPermission permission="ADM30" v-if="this.name">
    <b-overlay :show="loading" no-wrap />
    <div class="row">
      <div  class="col-md-8 d-flex align-items-end">
        <label>{{name}}</label>
        <InfoApprovalSigns/>
      </div>
      <div class="col-md-2">
        <vs-radio
          :data-cy="'parameter'+paramId+'-yes'"
          :disabled="disabled"
          vs-name="parameter"
          :vs-value="true"
          :value="value"
          @input="$emit('input', $event)"
        >
          Si
        </vs-radio>
      </div>
      <div class="col-md-2">
        <vs-radio
          :data-cy="'parameter'+paramId+'-no'"
          :disabled="disabled"
          vs-name="parameter"
          :vs-value="false"
          :value="value"
          @input="$emit('input', $event)"
        >
          No
        </vs-radio>
      </div>
    </div>
  </CheckPermission>
</template>
<script>

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import { ioGetConfiguration } from '@/febos/servicios/api/herramientas.api';
import InfoApprovalSigns from '@/febos/chile/approvals/wizardFlow/components/InfoApprovalSigns';

export default {
  components: { InfoApprovalSigns, CheckPermission },
  data() {
    return {
      name: '',
      loading: false
    };
  },
  methods: {
    async findParameter() {
      this.loading = true;
      const {
        name,
        value
      } = await ioGetConfiguration(this.paramId);
      this.name = name;
      this.loading = false;
      if (this.defaultFalse) {
        this.$emit('input', false);
        return;
      }
      this.$emit('input', value === 'Y');
    },
  },
  created() {
    this.findParameter();
  },
  props: {
    disabled: { type: Boolean, required: false, default: false },
    paramId: { type: String, required: true },
    value: { type: Boolean, required: true },
    defaultFalse: { type: Boolean, required: false },
    isApprovalSign: { type: Boolean, required: true, default: false }
  }
};

</script>
